import axios from "axios";
import config from "../config";
import { getDoctorToken } from "../utils"

const saveAppointmentNotAttendedStatusApi = async (params) => {
  const response = await axios({
    url: `${config.api.base_url}book-appointment/appointment-not-attended`,
    method: "put",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${getDoctorToken()}`
    },
  });

  return response;
};

export default saveAppointmentNotAttendedStatusApi;
